import { filterParams } from '../assets/helpers/funciones';
import { authInstance } from './axios';
let url = process.env.REACT_APP_API_URL;

export const sellerComissionService = {
  getComissionList: async (params) => {
    const response = await authInstance
      .get(
        `${url}/sellerComission/exportable?` +
          new URLSearchParams(filterParams(params))
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  getComissionConfig: async (params) => {
    const response = await authInstance
      .get(
        `${url}/sellerComissionConfig?` +
          new URLSearchParams(filterParams(params))
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  createComissionConfig: async (body) => {
    const response = await authInstance
      .post(`${url}/sellerComissionConfig/create`, body)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  updateComissionConfig: async (id, body) => {
    const response = await authInstance
      .put(`${url}/sellerComissionConfig/${id}/update`, body)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  recalculateComissionConfig: async (body) => {
    const response = await authInstance
      .put(`${url}/sellerComission/recalculate`, body)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },
};
